import { Link } from "react-router-dom";
import clsx from "clsx";

import { ArrowBackSVGIcon } from "components/SVGIcons";
import { useColorScheme } from "hooks/useColorScheme";
import { IUserSettingItem } from "models/UserSetting";
import styles from "./style.module.scss";

interface IProps {
  data: IUserSettingItem;
}

export default function UserSettingItem({ data }: Readonly<IProps>) {
  const { currentIsDark } = useColorScheme();

  return (
    <Link
      to={data.link}
      className={clsx(
        styles.userSettingItemContainer,
        !currentIsDark && "desktop:drop-shadow-[0_2px_4.5px_#B5B5B533]"
      )}>
      <div className={styles.body}>
        <div className={styles.content}>
          <data.iconHeader className={styles.icon} />
          <div className={styles.title}>
            <h3 className="text-sm desktop:text-xl">{data.title}</h3>
            <span className={styles.description}>{data.description}</span>
          </div>
        </div>
        <ArrowBackSVGIcon className="flex-none desktop:size-6" />
      </div>
    </Link>
  );
}
